import { useMutation } from '@tanstack/react-query';
import { request } from '../../axios';

export interface DuplicateCheckPayload {
    firstName?: string;
    lastName?: string;
    birthDate?: string;
    asylumNumber?: string;
    zemisNumber?: string;
    address?: string;
}

export interface DuplicatePersonMatch {
    id: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    gender: string | null;
    created: string | null;
    phone: string | null;
    email: string | null;
}

export interface DuplicateCheckResponse {
    firstNameMatches: DuplicatePersonMatch[];
    lastNameMatches: DuplicatePersonMatch[];
    birthDateMatches: DuplicatePersonMatch[];
    asylumNumberMatches: DuplicatePersonMatch[];
    zemisNumberMatches: DuplicatePersonMatch[];
    addressMatches: DuplicatePersonMatch[];
}

/**
 * Calls POST /api/persons/duplicate-check
 */
export function checkPersonDuplicate(payload: DuplicateCheckPayload) {
    return request<DuplicateCheckResponse>({
        url: '/api/persons/duplicate-check',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: payload,
    });
}

/**
 * React Query mutation for checking duplicates.
 */
export function useCheckPersonDuplicateMutation() {
    return useMutation({
        mutationFn: checkPersonDuplicate,
    });
}
